var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12327",
    "data-name": "Groupe 12327",
    transform: "translate(-0.666 -0.333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 16,
    height: 16,
    transform: "translate(0.666 0.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M4.741,14.667a.666.666,0,0,1-.662-.738L4.591,9.2H.667A.666.666,0,0,1,.113,8.163L5.372.3A.667.667,0,0,1,6.589.739L6.076,5.467H10A.667.667,0,0,1,10.554,6.5l-5.26,7.867A.664.664,0,0,1,4.741,14.667ZM4.97,3.3,1.914,7.867H5.333A.667.667,0,0,1,6,8.6l-.3,2.767L8.753,6.8H5.333a.667.667,0,0,1-.663-.738L4.97,3.3Z",
    transform: "translate(3.666 1.333)",
    fill: "#c5cee0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/sheets.f0aaa2b2e79b879fdb7e5858c986d14b.svg";
export { ForwardRef as ReactComponent };